
    import cityData from '@/assets/data/city.json';
    import {
        message
    } from 'ant-design-vue';
    import {
        defineComponent,
        onMounted,
        ref,
        reactive
    } from 'vue';
    import subjectList from '@/assets/data/subject.json';
	import studyPhaseList from '@/assets/data/studyPhase.json';
    import taskreviewer from '@/service/taskreviewer'
    import infouser from '@/service/infouser'

    export default defineComponent({
        components: {},
        setup(props, context) {
            // 声明
            let visible = ref(false);
            let formState = reactive({
                taskId: '',
                taskName: '',
                mode: '0',
                schoolCode: sessionStorage.getItem('schoolCode'),
                userType: '',
                loginName: '',
                userName: '',
                studyPhase: [],
                subject: [],
                tel: '',
                positionTitle: '',
                unit: '',
                reviewerType: '',
                district: [],
            });
            let peopleDateList = [];
            let peopleDateAllList = [];
            let selectUser = ref('');

            // 页面渲染时加载
            onMounted(() => {

            })
            // 打开页面
            const open = (taskId, taskName, identity) => {
                setForm();
                queryUserList();
                visible.value = true;
                selectUser.value = '';
                formState.taskId = taskId;
                formState.taskName = taskName;
                formState.reviewerType = identity;
            }
            // 获取用户管理人员
            const queryUserList = () => {
                let userList = [];
				let dataJSON={
					schoolCode:sessionStorage.getItem('schoolCode'),
					userType:'2'
				}
                infouser.queryUser(dataJSON).then(({data}) => {
                    if (data.code !== 0) return;
                    if(data.data){
                        data.data.map(item => {
							cityData[0].children[0].children.map(item2 => {
								if (item2.value == item.district) {
									item.districtMap = "上海市/市辖区/" + item2.label
								}
							})
							if(item.studyPhase==undefined || item.studyPhase==null || item.studyPhase==""){
								item.studyPhase ="-"
							}
							if(item.subject==undefined || item.subject==null || item.subject==""){
								item.subject ="-"
							}
							if(item.districtMap==undefined || item.districtMap==null || item.districtMap==""){
								item.districtMap ="-"
							}
                            userList.push({
                                label: item.userName + "," + item.studyPhase + ","+ item.subject +","+ item.districtMap,
                                value: item.id,
                            })
                        })
                    }
                    peopleDateAllList.value = data.data;
                    peopleDateList.value = userList;
                })
            }
            // 搜索用户管理的人员
            const filterOption = (input, option) => {
                return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
            };
            // 提交表单
            const handleOk = () => {
                let flag = true;
                let dataJson;
                if (formState.mode == "0") { //0手动添加 1用户管理添加
                    if (formState.loginName.length < 4 || formState.loginName.length > 18) {
                        message.warning('请输入4-18位登陆账号');
                        flag = false;
                    }
                    if (formState.userName == "") {
                        message.warning('请输入姓名');
                        flag = false;
                    }
                    dataJson = {
                        addType: formState.mode,
                        schoolCode: formState.schoolCode,
                        taskId: formState.taskId,
                        taskName: formState.taskName,
                        reviewerType: formState.reviewerType,
                        loginName: formState.loginName,
                        userName: formState.userName,
                        studyPhase: formState.studyPhase.length == 0 ? '' : formState.studyPhase.toString(),
                        subject: formState.subject.length == 0 ? '' : formState.subject.toString(),
                        tel: formState.tel,
                        positionTitle: formState.positionTitle,
                        unit: formState.unit,
                        district: formState.district ? formState.district[2] : ''
                    };
                } else {
                    if(selectUser.value == ''){
                        message.warning('请选择用户管理中的人员');
                        flag = false;
                    }
                    let selectUserInfo = peopleDateAllList.value[peopleDateAllList.value.findIndex(item => item.id == selectUser.value)];
                    console.log(selectUserInfo);
                    dataJson = {
                        addType: formState.mode,
                        schoolCode: formState.schoolCode,
                        taskId: formState.taskId,
                        taskName: formState.taskName,
                        reviewerType: formState.reviewerType,
                        loginName: selectUserInfo.loginName,
                        userId: selectUserInfo.id,
                        userName: selectUserInfo.userName,
                        studyPhase: selectUserInfo.studyPhase,
                        subject: selectUserInfo.subject,
                        tel: selectUserInfo.tel,
                        positionTitle: selectUserInfo.positionTitle,
                        unit: selectUserInfo.unit,
                        district: selectUserInfo.district,
                        userType: selectUserInfo.userType
                    };
                }

                if (flag) {
                    //保存个人信息
                    taskreviewer.saveTaskreviewer(dataJson).then(({data}) => {
                        if (data.code == '0') {
                            message.success(data.msg);
                            visible.value = false;
                            setForm();
                            context.emit('queryTable', '');
                        } else {
                            message.error(data.msg);
                        }
                    })
                }
            }
            //  清空表单
            const setForm = () => {
                formState.taskName = '';
                formState.taskId = '';
                formState.loginName = '';
                formState.studyPhase = [];
                formState.subject = [];
                formState.tel = '';
                formState.positionTitle = '';
                formState.unit = '';
                formState.reviewerType = '';
                formState.userName = '';
                formState.district = '';
                formState.userType = '';
                formState.mode = '0';
            }

            return {
                open,
                visible,
                formState,
                handleOk,
                peopleDateList,
                peopleDateAllList,
                selectUser,
                cityData,
                subjectList,
                setForm,
                queryUserList,
                filterOption,
				studyPhaseList
            };
        },

    });
